import { httpClient } from '@/services/http/httpClient'

type RemoveUsersParams = {
  evaluatorId: string
  ideaId: string
  stepId: string
}

export async function removeEvaluator({
  evaluatorId,
  ideaId,
  stepId,
}: RemoveUsersParams): Promise<void> {
  await httpClient.delete(`/ideas/evaluations/evaluators/${evaluatorId}`, {
    data: {
      ideaId,
      stepId,
    },
  })
}
